var BASWebServices;
(function (BASWebServices) {
    var FAQService = (function () {
        function FAQService($http) {
            this.$http = $http;
            this.faqContent = new Array();
            this.getFAQFromServer(BASWebServices.ConfigService.GET_FAQ_URL());
        }
        FAQService.Factory = function ($http) {
            return new FAQService($http);
        };
        FAQService.prototype.getFAQContent = function () {
            return this.faqContent;
        };
        FAQService.prototype.getFAQFromServer = function (path) {
            this.faqContent = this.$http.get(path);
        };
        return FAQService;
    }());
    BASWebServices.FAQService = FAQService;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=FAQService.js.map